// extracted by mini-css-extract-plugin
export var centerText = "_75-8";
export var container = "_75-0";
export var doughnutContainer = "_75-7";
export var legend = "_75-a";
export var legendItemColorDisplay = "_75-b";
export var legendItemLabel = "_75-d";
export var legendItemValue = "_75-c";
export var lg = "_75-5";
export var maxWidth = "_75-9";
export var md = "_75-4";
export var responsive = "_75-6";
export var sm = "_75-3";
export var xs = "_75-2";
export var xxs = "_75-1";